import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useRef } from 'react';
import { masterBlockColumns } from '@/constants/Block';
import SimpleTable from '@/components/combined/SimpleTable';
import getBlockServices from '@/api/blocks';
import getOverview from '@/api/overview';
import Icon from '@/components/base/Icon';
import { makeBlockListLink } from '@/utils/link';
import { makeShardBlockColumns } from '@/constants/Block';
import toasty from '@/components/base/Toast';
import { MASTER_TABLE_PAGE_SIZE } from '@/utils/constants';
import { globalShardFirst } from '@/utils/shard';
import Bubbles from '@/components/base/Spin/Bubbles';
import useLanguage from '@/hooks/useLanguage';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
var blockService = getBlockServices();
var overviewService = getOverview();
export var Banner = observer(function(props) {
    var currentHeight = props.currentHeight;
    var translate = useLanguage().translate;
    var ref1 = useState(currentHeight), height = ref1[0], setHeight = ref1[1];
    var timer = useRef(null);
    var pulse = useRef(true);
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getblock();
        }
    }, [
        refresh
    ]);
    var getblock = useCallback(function() {
        return overviewService.getOverview().then(function(r) {
            var ref = (r === null || r === void 0 ? void 0 : r.Result) || {}, Height = ref.Height, _BlockInterval = ref.BlockInterval, BlockInterval = _BlockInterval === void 0 ? 5000 : _BlockInterval;
            setHeight(String(Height));
            if (pulse.current) {
                if (timer.current) clearTimeout(timer.current);
                timer.current = setTimeout(function() {
                    return getblock();
                }, BlockInterval);
            }
        });
    }, [
        timer
    ]);
    useEffect(function() {
        getblock();
        return function() {
            pulse.current = false;
            (timer === null || timer === void 0 ? void 0 : timer.current) && clearTimeout(timer === null || timer === void 0 ? void 0 : timer.current);
        };
    }, []);
    useEffect(function() {
        setHeight(currentHeight);
    }, [
        currentHeight
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        onClick: props.onClick,
        className: "text-desc cursor-pointer text-[15px] font-[400] ml-[8px]",
        children: [
            translate('The latest block height is'),
            " ",
            /*#__PURE__*/ _jsxs("span", {
                className: "text-primary text-[15px] font-[400]",
                children: [
                    " #",
                    height
                ]
            })
        ]
    }));
});
function BlockListTable(props) {
    var title = props.title, className = props.className;
    var ref5 = useState('--'), height = ref5[0], setHeight = ref5[1];
    var ref2 = useState([]), masterBlocks = ref2[0], setMasterBlocks = ref2[1];
    var ref3 = useState(false), blocksLoading = ref3[0], setBlocksLoading = ref3[1];
    var ref4 = useState(false), blockExpandLoading = ref4[0], setBlockExpandLoading = ref4[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getBlocks();
        }
    }, [
        refresh
    ]);
    var getBlocks = useCallback(function() {
        setBlocksLoading(true);
        blockService.getMasterBlocks({
            limit: MASTER_TABLE_PAGE_SIZE,
            pos: 0
        }).then(function(response) {
            var ref;
            var Result = response.Result;
            var ListData = (Result || {}).ListData;
            setHeight(String(ListData === null || ListData === void 0 ? void 0 : (ref = ListData[0]) === null || ref === void 0 ? void 0 : ref.Height));
            setMasterBlocks(ListData);
        }).catch(function(ex) {
            return toasty({
                type: 'error',
                content: ex.Message
            });
        }).finally(function() {
            return setBlocksLoading(false);
        });
    }, []);
    var expandedBlockRowRender = useCallback(function(record) {
        return(/*#__PURE__*/ _jsx(SimpleTable, {
            data: record.expandable || [],
            columns: makeShardBlockColumns({
                expandable: 'block',
                isMaster: true
            }),
            indicator: /*#__PURE__*/ _jsx(Bubbles, {}),
            tableLayout: "fixed",
            showHeader: false,
            loading: record.expandable === undefined,
            rowKey: "ShardIndex"
        }));
    }, [
        masterBlocks,
        blockExpandLoading
    ]);
    var handleBlockExpand = useCallback(function(expanded, record) {
        if (expanded) {
            setBlockExpandLoading(true);
            blockService.getShardBlocks({
                height: record.Height
            }).then(function(response) {
                var Status = response.Status, Result = response.Result, Message = response.Message;
                if (Status === 0) {
                    var ListData = (Result || {}).ListData;
                    record.expandable = globalShardFirst(ListData);
                    return;
                }
                toasty({
                    type: 'error',
                    content: Message
                });
            }).finally(function() {
                return setBlockExpandLoading(false);
            });
            return;
        }
    }, [
        masterBlocks
    ]);
    useEffect(function() {
        getBlocks();
    }, []);
    var handleRefresh = useCallback(function() {
        var ref;
        getBlocks();
        (ref = props.onRefresh) === null || ref === void 0 ? void 0 : ref.call(props);
        refreshStore.setRefresh(true);
    }, [
        props.onRefresh
    ]);
    var uniqueKey = function(row) {
        return row.Timestamp + '-' + row.Height;
    };
    return(/*#__PURE__*/ _jsx(SimpleTable, {
        loading: blocksLoading,
        title: title,
        banner: /*#__PURE__*/ _jsx(Banner, {
            onClick: handleRefresh,
            currentHeight: height
        }),
        columns: masterBlockColumns,
        data: masterBlocks,
        rowKey: uniqueKey,
        tableLayout: "fixed",
        moreHref: makeBlockListLink(),
        onRefresh: handleRefresh,
        rowClassName: "cursor-pointer",
        className: className,
        expandable: {
            expandRowByClick: true,
            defaultExpandedRowKeys: [
                'ShardIndex'
            ],
            expandedRowRender: expandedBlockRowRender,
            onExpand: handleBlockExpand,
            showExpandColumn: true,
            expandIcon: function(param) {
                var record = param.record, onExpand = param.onExpand, expanded = param.expanded;
                /*#__PURE__*/ return _jsx(Icon, {
                    onClick: function(e) {
                        return e && onExpand(record, e);
                    },
                    type: expanded ? 'unexpand' : 'expand',
                    size: 20
                });
            }
        }
    }));
}
export default observer(BlockListTable);
